import React from 'react';
import Rating from '@mui/material/Rating';

export const NotEnoughReting = () => {
  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center"
    }}>   
      <div style={{padding: "1.5rem"}} />
      <Rating
        name="half-rating"
        value={0}
        precision={0.2}
        readOnly
      />            
      <p className="text text--user_profile_rating">
        Not enough ratings yet
      </p>
    </div>
  );
};